module.exports = __webpack_public_path__ + "img/biter-run-mask2.2f096df3.png";